'use client';

import { CatButton } from '@blocks-react/components/Button';
import { CatPopover } from '@blocks-react/components/Popover';
import { useTranslations } from 'next-intl';
import ContactDealerPopoverContent from '../contact-dealer-popover-content/contact-dealer-popover-content';
import { LocationAddress } from 'services/location/types';
import { Position, Variant, Size } from '../types';
import styles from './contact-your-dealer-popover.module.scss';
import cx from 'classnames';

interface ContactYourDealerPopoverProps {
  locale: string;
  dealerAddress: LocationAddress;
  position?: Position;
  isCustomerSupportEnabled?: boolean;
  variant?: Variant;
  className?: string;
  size?: Size;
  responsiveBehavior?: boolean;
  msg?: string;
  shouldFitContent?: boolean;
  shouldMaxContent?: boolean;
}
export default function ContactYourDealerPopover({
  locale,
  dealerAddress,
  position = 'bottom',
  isCustomerSupportEnabled = false,
  variant,
  className = 'w-100',
  size = 'sm',
  responsiveBehavior = true,
  msg,
  shouldFitContent,
  shouldMaxContent
}: Readonly<ContactYourDealerPopoverProps>) {
  const t = useTranslations();
  const popoverTitle = msg || t('CONTACT_YOUR_DEALER');
  return (
    <CatPopover
      {...(responsiveBehavior && { behavior: 'responsive' })}
      headingVariant="title-sm"
      heading={t('FOOTER_CONTACT_US')}
      className={cx(className, {
        [styles['contact-dealer-popover--fit-content']]: shouldFitContent,
        [styles['contact-dealer-popover--max-content']]: shouldMaxContent
      })}
      position={position}
    >
      <CatButton
        {...(variant && { variant })}
        size={size}
        fullWidth
        slot="trigger"
        className={cx({
          [styles['contact-dealer-popover__button--max-content']]:
            shouldMaxContent
        })}
      >
        {popoverTitle}
      </CatButton>
      <ContactDealerPopoverContent
        dealerAddress={dealerAddress}
        locale={locale}
        isCustomerSupportEnabled={isCustomerSupportEnabled}
      />
    </CatPopover>
  );
}
